module.exports = __webpack_public_path__ + "static/img/find_team_icon.b3f3a00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestivalActive/light/find_team_icon.png
// module id = L2DK
// module chunks = 1